import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BorderRightIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 3h2v2h-2zM7 3h2v2h-2zM11 3h2v2h-2zM15 3h2v2h-2zM19 3h2v18h-2zM3 7h2v2h-2zM11 7h2v2h-2zM3 11h2v2h-2zM7 11h2v2h-2zM11 11h2v2h-2zM15 11h2v2h-2zM3 15h2v2h-2zM11 15h2v2h-2zM3 19h2v2h-2zM7 19h2v2h-2zM11 19h2v2h-2zM15 19h2v2h-2z"
      fill="currentColor"
    />
  </svg>
);

BorderRightIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BorderRightIcon);
